import React from 'react'

import img from './../../assets/schoolChail.png';
const RmsChail = () => {
  return (
    <>
    <div style={{ backgroundImage: `url(${img})`,height: '370px',
width: '100%', backgroundRepeat:"no-repeat", backgroundSize:"cover"}} ></div>
    <div className="container-fluid px-5 mb-3" >
      

      <header className=" mt-3 pt-3">
        <h3>RMS Chail</h3>

      </header>
      <div className="section pb-3">
                         
                          <div className="content-container mt-3">
                          <p>
                        Rashtriya Military School Chail (Shimla Hills) is a residential English Medium Public School under the Ministry of Defence. The foundation of this school was laid by the Prince of Wales in Feb 1922 and the School started functioning in Sep 1925 at Jalandhar Cantt. In 1952 the School was shifted to Nowgong (MP) and was moved to its present location at Chail in 1960. The school was renamed as Chail Military School with effect from 01 Jan 1966 and now as Rashtriya Military School Chail wef 25 Jun 2007. Rashtriya Military Chail was initially known as King George V's Royal Indian Military School, later called as King George V's Royal Indian Military College and then as King George's School. Military Schools provided education to sons of the Defence Service personnel and prepared them for career in the Armed Forces. In 1952 Rashtriya Military Schools were organized as residential Public Schools for boys. Their objectives were enlarged and admissions were thrown open to the sons of Defence Service Officers and Civilians. These Schools are the members of Indian public Schools conference.
                        The School Office functions from 0830 hrs to 1430 hrs and 1530 hrs to 1630 hrs on all working days, school office will remain closed on Sundays and Holidays. The Academic and Administrative head of the school is the Principal who is assisted by Administrative Officer of the rank of Captain/Major from Army.


                    </p>
          
                          </div>
                      </div>
                      </div>
                      </>
  )
}

export default RmsChail
